var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10C16 7.79 14.21 6 12 6C9.79 6 8 7.79 8 10C8 12.21 9.79 14 12 14C14.21 14 16 12.21 16 10ZM10 10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12C10.9 12 10 11.1 10 10Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.42 21.81C11.59 21.93 11.8 22 12 22C12.2 22 12.41 21.94 12.58 21.81C12.88 21.59 20.03 16.44 20 9.98999C20 5.57999 16.41 1.98999 12 1.98999C7.58997 1.98999 3.99997 5.57999 3.99997 9.98999C3.96997 16.43 11.12 21.59 11.42 21.81ZM12 3.99999C15.31 3.99999 18 6.68999 18 9.99999C18.02 14.44 13.61 18.43 12 19.74C10.39 18.43 5.97997 14.45 5.99997 9.99999C5.99997 6.68999 8.68997 3.99999 12 3.99999Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.b30f7e6c96a9addf5f803a2a483463b9.svg";
export { ForwardRef as ReactComponent };